var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-wrap"},[(this.mess != '')?_c('button',{class:_vm.classBtn,on:{"click":_vm.handler}},[_vm._v(" "+_vm._s(this.valueBtn)+" ")]):_vm._e(),(this.mess === '')?_c('button',{class:_vm.classBtn,domProps:{"innerHTML":_vm._s(this.valueBtn)},on:{"click":_vm.handler}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }